import React, { useEffect, useState } from 'react'
import MaterialData from '../../Common/MaterialData';
import { useLocation, useParams } from 'react-router-dom';

export default function MaterialScreen() {
  const location = useLocation()
  const [Material, setMaterial] = useState([...MaterialData.data])
  const [Furniture, setFurniture] = useState([...MaterialData.furniture])
  const [category, setcategory] = useState(location.pathname.split("/")[2])
  const getMaterial = (category) => {
    if (category === "all") {
      setFurniture([...MaterialData.furniture])
      setMaterial([...MaterialData.data])
    } else {
      if (category === "furniture") {
        setMaterial([])
        setFurniture([...MaterialData.furniture])
      } else {
        const product = [...MaterialData.data].filter((x) => x.category.split("_")[2] === category)
        setMaterial(product)
        setFurniture([])
      }
    }
  }

  useEffect(() => {
    const category = location.pathname.split("/")[2]
    getMaterial(category)
  }, [location.pathname])

  return (
    <div className='MaterialScreen'>
      <div className="container my-3">
        {
          Material.length > 0 && <div className="h4">Feature Material</div>
        }
        <div className="row">
          {
            Material && Material?.map((data, index) => {
              return <div className="col-12 my-2 my-2">
                <div className="row">
                  <div className="col-12 col-md-4 my-2">
                    <div className="text-center">
                      <img src={data?.img} alt="" width={"80%"} height={index < 16 ? "460px" : "250px"} />
                    </div>
                  </div>
                  <div className="col-12 col-md-8 my-2">
                    <div className="card p-3">
                      <div className="h5 text_main">{data.title}</div>
                      <div className="h6 mt-3">Specification : </div>
                      <table className='my-2'>
                        <tr className='w-100'>
                          <td className='border p-1 w-25'>Material</td>
                          <td className='border p-1 w-75'>{data.material}</td>
                        </tr>
                        <tr className='w-100'>
                          <td className='border p-1 w-25'>Colors</td>
                          <td className='border p-1 w-75'>{data.color}</td>
                        </tr>
                        <tr className='w-100'>
                          <td className='border p-1 w-25'>Size</td>
                          <td className='border p-1 w-75'>{data.size}</td>
                        </tr>
                        <tr className='w-100'>
                          <td className='border p-1 w-25'>Thickness</td>
                          <td className='border p-1 w-75'>{data.thickness}</td>
                        </tr>
                      </table>
                      <div className="h6 mt-3">Description : </div>
                      <ul style={{ listStyle: "initial" }}>
                        {
                          data.description?.map((item) => {
                            return <li><span className=''>{item.title} : </span> <span className='text-muted'>{item.note}</span></li>
                          })
                        }
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            })
          }
        </div>
        {
          Furniture.length > 0 && <div className="h4">Furniture Sheets</div>
        }
        <div className="row">
          {
            Furniture && Furniture?.map((data, index) => {
              return <div className="col-12 my-2 my-2">
                <div className="row">
                  <div className="col-12 col-md-4 my-2">
                    <div className="text-center">
                      <img src={data?.img} alt="" width={"80%"} height={index < 16 ? "460px" : "250px"} />
                    </div>
                  </div>
                  <div className="col-12 col-md-8 my-2">
                    <div className="card p-3">
                      <div className="h5 text_main">{data.title}</div>
                      <div className="h6 mt-3">Specification : </div>
                      <table className='my-2'>
                        <tr className='w-100'>
                          <td className='border p-1 w-25'>Material</td>
                          <td className='border p-1 w-75'>PVC</td>
                        </tr>
                        <tr className='w-100'>
                          <td className='border p-1 w-25'>Colors</td>
                          <td className='border p-1 w-75'>{data.color}</td>
                        </tr>
                      </table>
                      <div className="h6 mt-3">Sizes : </div>
                      <table>
                        {
                          data.size && data.size.map((item, i) => {
                            return (
                              <>
                                <tr className='w-100'>
                                  <td className='border p-1 w-25'>{i + 1}</td>
                                  <td className='border p-1 w-75'>
                                    {item}
                                  </td>
                                </tr>
                              </>
                            )
                          })
                        }
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            })
          }
        </div>
      </div>
    </div>
  )
}
